<template>
  <div class="nosotros-view">

    <!-- Quiénes somos -->
    <section class="about-hero">
      <div class="about-hero-text">
        <div class="logo-badge">
          <img src="/img/Logo.jpg" alt="Logo Tasoar" class="logo-badge-img">
        </div>

        <h1>¿Quiénes somos?</h1>

        <p>
          En <strong>Taller de Soluciones Arquitectónicas (TASOAR)</strong>, somos un
          <strong>contratista general</strong> especializado en transformar ideas y necesidades
          en realidades estructurales sólidas.
        </p>
        <p>
          Con un enfoque integral, abarcamos desde la conceptualización y el desarrollo de
          proyectos ejecutivos, hasta la edificación, construcción y mantenimiento preventivo
          de inmuebles. En <strong>TASOAR</strong>, funcionamos como el único punto de contacto
          y coordinación para nuestros clientes, garantizando eficiencia de costos, control
          riguroso de tiempos y los más altos estándares de calidad técnica en cada etapa de la obra.
        </p>

        <div class="philosophy-box">
          <div class="philosophy-icon"><i class="fa-solid fa-people-group"></i></div>
          <div class="philosophy-content">
            <h2>Nuestra Filosofía:</h2>
            <p class="philosophy-tagline">We build together <span>(Construimos juntos)</span></p>
            <p class="philosophy-text">
              En <strong>TASOAR</strong>, creemos que los grandes proyectos no se imponen, se co-crean.
              Trabajamos hombro con hombro con nuestros clientes, ingenieros y proveedores para que
              cada plano ejecutivo, cada muro edificado y cada labor de mantenimiento sea el resultado
              de un esfuerzo coordinado y transparente.
            </p>
          </div>
        </div>
      </div>

      <div class="about-hero-image">
        <img src="/img/nosotros-banner.png" alt="Vista aérea de la estatua de Cristo Rey al atardecer">
      </div>
    </section>

    <!-- Barra de valores -->
    <section class="about-values-bar">
      <div class="values-bar-container">
        <div class="value-item">
          <i class="fa-solid fa-compass-drafting"></i>
          <div class="value-text">
            <strong>DISEÑAMOS</strong>
            <span>CON VISIÓN</span>
          </div>
        </div>
        <div class="value-item">
          <i class="fa-solid fa-helmet-safety"></i>
          <div class="value-text">
            <strong>CONSTRUIMOS</strong>
            <span>CON CALIDAD</span>
          </div>
        </div>
        <div class="value-item">
          <i class="fa-solid fa-clipboard-check"></i>
          <div class="value-text">
            <strong>CUMPLIMOS</strong>
            <span>CON RESPONSABILIDAD</span>
          </div>
        </div>
        <div class="value-item">
          <i class="fa-solid fa-handshake"></i>
          <div class="value-text">
            <strong>ENTREGAMOS</strong>
            <span>CON ORGULLO</span>
          </div>
        </div>
        <div class="values-bar-logo">
          <img src="/img/Logo.jpg" alt="Logo Tasoar">
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'NosotrosView'
};
</script>

<style scoped>
.nosotros-view {
  color: #2c3e50;
}

/* --- Quiénes somos --- */
.about-hero {
  display: grid;
  grid-template-columns: 1.15fr 1fr;
  align-items: stretch;
  min-height: 640px;
}

.about-hero-text {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 50px 60px 50px 70px;
  background: linear-gradient(135deg, #eef3f9 0%, #dbe6f2 100%);
  text-align: left;
}

.logo-badge {
  align-self: flex-start;
  background-color: var(--color-primary);
  padding: 18px 20px 18px 0px;
  margin-bottom: 10px;
  clip-path: polygon(0 0, 100% 0, 88% 100%, 0% 100%);
}

.logo-badge-img {
  height: 100px;
  width: auto;
  display: block;
}

.about-hero-text h1 {
  font-size: 2.4rem;
  color: var(--color-primary);
  margin: 0;
  position: relative;
  padding-bottom: 18px;
}

.about-hero-text h1::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 70px;
  height: 4px;
  background-color: var(--color-primary);
}

.about-hero-text p {
  font-size: 1rem;
  line-height: 1.65;
  color: #333;
  margin: 0;
}

.about-hero-text p strong {
  color: var(--color-primary);
}

/* Caja de filosofía */
.philosophy-box {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  background-color: var(--color-primary);
  border-radius: 12px;
  padding: 25px 30px;
  margin-top: 10px;
}

.philosophy-icon {
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: #ffffff;
}

.philosophy-content h2 {
  color: #ffffff;
  font-size: 1.15rem;
  margin: 0 0 4px 0;
}

.philosophy-tagline {
  font-style: italic;
  font-weight: 700;
  font-size: 1rem;
  margin: 0 0 12px 0;
}

.philosophy-box .philosophy-tagline {
  color: #e0b34d;
}

.philosophy-tagline span {
  font-weight: 500;
  font-style: italic;
}

.philosophy-text {
  font-size: 0.9rem;
  line-height: 1.6;
  margin: 0;
}

.philosophy-box .philosophy-text {
  color: #dbe6f2;
}

.philosophy-box .philosophy-text strong {
  color: #ffffff;
}

.about-hero-image {
  position: relative;
  overflow: hidden;
}

.about-hero-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* --- Barra de valores --- */
.about-values-bar {
  background-color: var(--color-primary);
  padding: 30px 20px;
}

.values-bar-container {
  max-width: 1300px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.value-item {
  display: flex;
  align-items: center;
  gap: 15px;
  flex: 1 1 200px;
  padding: 0 20px;
}

.value-item:not(:last-of-type) {
  border-right: 1px solid rgba(255, 255, 255, 0.2);
}

.value-item i {
  font-size: 2rem;
  color: #ffffff;
  flex-shrink: 0;
}

.value-text {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.value-text strong {
  font-size: 0.85rem;
  font-weight: 800;
  color: #ffffff;
  letter-spacing: 0.5px;
}

.value-text span {
  font-size: 0.75rem;
  color: #cfe0f5;
  font-weight: 500;
}

.values-bar-logo {
  margin-left: auto;
  flex: 0 0 auto;
}

.values-bar-logo img {
  height: 40px;
  width: auto;
  display: block;
}

/* --- Responsivo --- */
@media (max-width: 1100px) {
  .about-hero-text {
    padding: 45px 40px;
  }
}

@media (max-width: 900px) {
  .about-hero {
    grid-template-columns: 1fr;
    min-height: auto;
  }

  .about-hero-image {
    order: 2;
    min-height: 320px;
  }

  .about-hero-text {
    order: 1;
    padding: 45px 30px;
  }

  .value-item:not(:last-of-type) {
    border-right: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    padding-bottom: 15px;
  }

  .values-bar-container {
    flex-direction: column;
    align-items: stretch;
  }

  .value-item {
    justify-content: center;
    text-align: center;
  }

  .value-text {
    text-align: center;
  }

  .values-bar-logo {
    margin: 10px auto 0 auto;
  }
}

@media (max-width: 600px) {
  .about-hero-text h1 {
    font-size: 1.8rem;
  }

  .philosophy-box {
    flex-direction: column;
    align-items: flex-start;
    padding: 20px;
  }
}

@media (max-width: 480px) {
  .about-hero-text {
    padding: 35px 20px;
  }

  .logo-badge {
    padding: 14px 30px 14px 18px;
  }

  .logo-badge-img {
    height: 34px;
  }
}
</style>